export default __webpack_public_path__ + "static/media/img-3.13e02027.png";